import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import { navigate } from "gatsby";
import { useLocation } from "@reach/router";

import { useClickOutside } from "./hooks/useClickOutside";

const LanguageSwitcher = ({ className, toggleMenu, menuOpen, theme }) => {
  const location = useLocation().pathname;
  const container = useRef(null);
  const [open, setOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(
    location === "/"
      ? "De"
      : location.charAt(1).toUpperCase() + location.charAt(2)
  );
  const languages = ["De", "En", "Es"];
  let currentLink = location.substring(3);

  useClickOutside(container, () => setOpen(false), open);

  return (
    <div ref={container} className={"relative " + className}>
      <button
        className={
          "relative border h-8 rounded-3xl z-20 " +
          (theme === "light" && !open
            ? "border-white"
            : "border-secondary bg-white")
        }
        style={{ width: 50 }}
        onClick={() => setOpen(!open)}
      >
        <span
          className={
            "text-p3 font-bold " +
            (theme === "light" && !open ? "text-white" : "text-secondary")
          }
        >
          {selectedLanguage}
        </span>
      </button>
      <div
        className={
          "absolute h-auto bg-white border border-secondary rounded-lg px-1 pt-7 pb-1 z-10 shadow-lg top-1 right-1/2 transform translate-x-1/2 " +
          (open ? "block" : "hidden")
        }
        style={{ width: 50 }}
      >
        {languages.map((lang, index) => {
          return lang === "Es" ? (
            <a
              key={index}
              className="relative flex justify-center gap-x-4 items-center rounded-lg hover:bg-gray-g1"
              style={{ width: 42, height: 26 }}
              href="https://prod.marbet.com/es"
            >
              <p className="hover:text-blue-informative text-p3 text-secondary">
                {lang}
              </p>
            </a>
          ) : (
            <button
              key={index}
              className="relative flex justify-center gap-x-4 items-center rounded-lg hover:bg-gray-g1"
              style={{ width: 42, height: 26 }}
              onClick={() => {
                setOpen(false);
                setSelectedLanguage(languages[index]);
                navigate(
                  lang === "En"
                    ? "/de/comingsoon"
                    : `/${languages[index].toLowerCase()}${currentLink}`
                );
                if (menuOpen) toggleMenu();
              }}
            >
              <p className="hover:text-blue-informative text-p3 text-secondary">
                {lang}
              </p>
            </button>
          );
        })}
      </div>
    </div>
  );
};

LanguageSwitcher.propTypes = {
  toggleMenu: PropTypes.func,
  menuOpen: PropTypes.bool,
  theme: PropTypes.string,
};

LanguageSwitcher.defaultProps = {
  toggleMenu: () => null,
  menuOpen: false,
  theme: "dark",
};
export default LanguageSwitcher;
